import { render } from "./paymment-plans.vue?vue&type=template&id=3c86756a"
import script from "./paymment-plans.vue?vue&type=script&lang=js"
export * from "./paymment-plans.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__